import { fetchFetchTranslation } from "@lookiero/i18n";
const fetchTranslations = ({ translations }) => async ({ locale }) => {
    const urls = translations.flatMap((endpoint) => endpoint(locale));
    const translationsMessages = await Promise.all(urls.map((url) => fetchFetchTranslation({ endpoint: () => url })({ locale })));
    return translationsMessages.reduce((acc, translationMessages) => ({
        ...acc,
        ...translationMessages,
    }), {});
};
export { fetchTranslations };
